import { render, staticRenderFns } from "./GOODS_Special.vue?vue&type=template&id=607e37c4&"
import script from "./GOODS_Special.vue?vue&type=script&lang=js&"
export * from "./GOODS_Special.vue?vue&type=script&lang=js&"
import style0 from "./GOODS_Special.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports